(function () {
    var serviceBtn = document.getElementById('acs-tire-service-btn');
    var cowlendarTrigger = document.getElementById('acs-cowlendar-hidden-trigger');
    var btnMit = document.getElementById('acs-btn-mit');
    var btnOhne = document.getElementById('acs-btn-ohne');
    var optionMit = document.getElementById('acs-option-mit');
    var optionOhne = document.getElementById('acs-option-ohne');
    var warningEl = document.getElementById('acs-tire-service-warning');
    var infoEl = document.getElementById('acs-tire-service-info');

    if (!serviceBtn || !cowlendarTrigger) return;

    /* ── Cowlendar variant mapping (quantity → btn ID) ── 
    var cowlendarVariants = {
        1: '69d927d86b383990f7a02143-55500904005972',
        2: '69d927d86b383990f7a02143-55500904038740',
        3: '69d927d86b383990f7a02143-55745617068372',
        4: '69d927d86b383990f7a02143-55500904071508',
    };
    */

    /* ── Cowlendar variant mapping (quantity → btn ID), seçili bölgeye göre değişir ── */
    var fallbackCowlendarVariants = {
        1: '69d927d86b383990f7a02143-55500904005972',
        2: '69d927d86b383990f7a02143-55500904038740',
        3: '69d927d86b383990f7a02143-55745617068372',
        4: '69d927d86b383990f7a02143-55500904071508',
    };

    function getCowlendarVariants() {
        var region = window.acsRegionManager?.getRegion();
        return (region && region.tireCowlendar) || fallbackCowlendarVariants;
    }
    var cowlendarVariants = getCowlendarVariants();

    var polling = false;
    var pollTimer = null;
    var pollTimeout = null;
    var cowMessageHandler = null;
    var cowBgObserver = null;
    var cowBodyObserver = null;
    var POLL_INTERVAL = 2000;
    var MAX_POLL_DURATION = 300000;

    var config = document.getElementById('acs-reifenwechsel-wrapper').dataset;
    if (!config) return;
    var sectionId = config.sectionId;
    if (!sectionId) return;
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    function getVariantId() {
        var input = document.getElementById('acs-product-variant-id');
        return input ? input.value : null;
    }

    function getQuantity() {
        var input = document.getElementById('Quantity-' + sectionId);
        return input ? parseInt(input.value, 10) || 1 : 1;
    }

    /* ── Reifenwechsel radio toggle ── */
    var radios = document.querySelectorAll('input[name="acs-reifenwechsel"]');
    function handleRadioChange() {
        var isMit = document.querySelector('input[name="acs-reifenwechsel"]:checked').value === 'mit';
        btnMit.classList.toggle('tw-hidden', !isMit);
        btnOhne.classList.toggle('tw-hidden', isMit);
        optionMit.classList.toggle('tw-border-slate-800', isMit);
        optionMit.classList.toggle('tw-border-slate-200', !isMit);
        optionOhne.classList.toggle('tw-border-slate-800', !isMit);
        optionOhne.classList.toggle('tw-border-slate-200', isMit);

        if (!isMit) {
            fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { '_reifenwechsel': 'ohne' } }),
            }).catch(function () {});
        }
    }
    radios.forEach(function (r) {
        r.addEventListener('change', handleRadioChange);
    });

    /* ── Quantity değişince Cowlendar variant güncelle ── */
    function updateCowlendarVariant() {
        var qty = getQuantity();
        if (qty > 4) {
            serviceBtn.setAttribute('aria-disabled', 'true');
            serviceBtn.classList.add('tw-opacity-40', 'tw-pointer-events-none');
            warningEl.classList.remove('tw-hidden');
            infoEl.classList.add('tw-hidden');
            return;
        }
        serviceBtn.removeAttribute('aria-disabled');
        serviceBtn.classList.remove('tw-opacity-40', 'tw-pointer-events-none');
        warningEl.classList.add('tw-hidden');
        infoEl.classList.remove('tw-hidden');

        var btnId = cowlendarVariants[qty] || cowlendarVariants[1];
        cowlendarTrigger.setAttribute('data-cowlendar-btn', btnId);
    }

    var qtyInput = document.getElementById('Quantity-' + sectionId);
    if (qtyInput) {
        qtyInput.addEventListener('change', updateCowlendarVariant);
        var qtyContainer = qtyInput.closest('quantity-input');
        if (qtyContainer) {
            qtyContainer.querySelectorAll('button').forEach(function (b) {
                b.addEventListener('click', function () {
                    setTimeout(updateCowlendarVariant, 50);
                });
            });
        }
    }
    updateCowlendarVariant();

    if (typeof subscribe === 'function') {
        subscribe('acs-region-changed', function () {
            cowlendarVariants = getCowlendarVariants();
            updateCowlendarVariant();
        });
    }

    /* ── Cowlendar popup açık mı kontrol ── */
    function isCowlendarOpen() {
        var bg = document.querySelector('.cowlendar-bg.cowlendar-root');
        if (!bg) return false;
        return bg.style.display !== 'none' && document.body.classList.contains('cowlendar-overflow-fixed');
    }

    /* ── Cowlendar popup'ı kapatma (Cowlendar R() ile aynı mantık) ── */
    function closeCowlendarPopup() {
        var bg = document.querySelector('.cowlendar-bg.cowlendar-root');
        if (bg) bg.style.display = 'none';
        document.body.classList.remove('cowlendar-overflow-fixed');
        console.log('acs-tire-service: Cowlendar popup kapatildi');
    }

    /* ── Tüm Cowlendar izleyicilerini temizle ── */
    function cleanupAllWatchers() {
        if (cowMessageHandler) {
            window.removeEventListener('message', cowMessageHandler);
            cowMessageHandler = null;
        }
        if (cowBgObserver) {
            cowBgObserver.disconnect();
            cowBgObserver = null;
        }
        if (cowBodyObserver) {
            cowBodyObserver.disconnect();
            cowBodyObserver = null;
        }
    }

    /* ── Cowlendar kapanışını izle (3 yöntem birden) ── */
    function startCowlendarWatchers() {
        cleanupAllWatchers();

        /* 1) postMessage: X butonu tıklandığında iframe "close" gönderir */
        cowMessageHandler = function (event) {
            var action = event && event.data && event.data.action;
            if (action === 'close') {
                console.log('acs-tire-service: close postMessage alindi (X basildi)');
                if (polling) stopPolling();
            }
        };
        window.addEventListener('message', cowMessageHandler);

        /* 2) MutationObserver: backdrop tıklandığında Cowlendar .cowlendar-bg style=display:none yapar */
        var bg = document.querySelector('.cowlendar-bg.cowlendar-root');
        if (bg) {
            cowBgObserver = new MutationObserver(function () {
                if (polling && bg.style.display === 'none') {
                    console.log('acs-tire-service: backdrop kapanisi algilandi (bg display:none)');
                    stopPolling();
                }
            });
            cowBgObserver.observe(bg, { attributes: true, attributeFilter: ['style'] });
        }

        /* 3) Body class izle: cowlendar-overflow-fixed kaldırılınca popup kapanmış demektir */
        cowBodyObserver = new MutationObserver(function () {
            if (polling && !document.body.classList.contains('cowlendar-overflow-fixed')) {
                console.log('acs-tire-service: body class kapanisi algilandi (overflow-fixed kaldirildi)');
                stopPolling();
            }
        });
        cowBodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }

    /* ── Polling & cart logic ── */
    function stopPolling() {
        polling = false;
        if (pollTimer) {
            clearInterval(pollTimer);
            pollTimer = null;
        }
        if (pollTimeout) {
            clearTimeout(pollTimeout);
            pollTimeout = null;
        }
        cleanupAllWatchers();
        serviceBtn.removeAttribute('aria-disabled');
        serviceBtn.classList.remove('tw-opacity-60', 'tw-pointer-events-none');
    }

    function addTireToCart(variantId, quantity) {
        var sectionsToRender = cart
            ? cart.getSectionsToRender().map(function (s) {
                return s.id;
            })
            : [];

        var body = JSON.stringify({
            items: [{ id: parseInt(variantId, 10), quantity: quantity, properties: { '_delivery_type': 'werkstatt' } }],
            sections: sectionsToRender,
            sections_url: window.location.pathname,
        });

        return fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/javascript',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: body,
        })
            .then(function (res) {
                return res.json();
            })
            .then(function (response) {
                if (response.status) {
                    console.error('acs-tire-service: Lastik sepete eklenemedi', response);
                    closeCowlendarPopup();
                    return;
                }

                if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: 'acs-tire-service',
                        productVariantId: variantId,
                        cartData: response,
                    });
                }

                try {
                    if (cart && typeof cart.renderContents === 'function') {
                        cart.renderContents(response);
                    }
                } catch (e) {
                    console.warn('acs-tire-service: renderContents hatasi (görmezden gelindi)', e);
                }

                console.log('acs-tire-service: Lastik sepete eklendi', { variantId: variantId, quantity: quantity });

                /* Cart attributes güncelle: _reifenwechsel = mit */
                fetch(window.routes.cart_update_url || '/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ attributes: { '_reifenwechsel': 'mit' } }),
                }).catch(function () {});

                /* Popup kapat → 2sn sonra sepete yönlendir */
                setTimeout(function () {
                    closeCowlendarPopup();
                    setTimeout(function () {
                        window.location.href = '/cart';
                    }, 1500);
                }, 500);
            })
            .catch(function (err) {
                console.error('acs-tire-service: fetch hatasi', err);
                closeCowlendarPopup();
            });
    }

    serviceBtn.addEventListener('click', function () {
        if (polling) return;
        if (serviceBtn.getAttribute('aria-disabled') === 'true') return;

        var variantId = getVariantId();
        var quantity = getQuantity();

        if (!variantId) {
            console.warn('acs-tire-service: variant ID bulunamadi');
            return;
        }

        serviceBtn.setAttribute('aria-disabled', 'true');
        serviceBtn.classList.add('tw-opacity-60', 'tw-pointer-events-none');

        fetch('/cart.js', { method: 'GET', headers: { Accept: 'application/json' } })
            .then(function (res) {
                return res.json();
            })
            .then(function (cartData) {
                var initialItemCount = cartData.item_count;

                cowlendarTrigger.style.pointerEvents = 'auto';
                cowlendarTrigger.click();
                cowlendarTrigger.style.pointerEvents = 'none';

                polling = true;

                /* Cowlendar kapanış izleyicilerini başlat (X, backdrop, body class) */
                startCowlendarWatchers();

                pollTimer = setInterval(function () {
                    fetch('/cart.js', { method: 'GET', headers: { Accept: 'application/json' } })
                        .then(function (res) {
                            return res.json();
                        })
                        .then(function (currentCart) {
                            if (currentCart.item_count > initialItemCount) {
                                stopPolling();
                                addTireToCart(variantId, quantity);
                            }
                        })
                        .catch(function () { });
                }, POLL_INTERVAL);

                pollTimeout = setTimeout(function () {
                    console.log('acs-tire-service: polling timeout');
                    stopPolling();
                }, MAX_POLL_DURATION);
            })
            .catch(function (err) {
                console.error('acs-tire-service: cart fetch hatasi', err);
                stopPolling();
            });
    });
})();